export enum UserRole {
  EMPLOYEE = 'EMPLOYEE',
  DEPARTMENT_MANAGER = 'DEPARTMENT_MANAGER',
  SENIOR_MANAGER = 'SENIOR_MANAGER',
  GENERAL_MANAGER = 'GENERAL_MANAGER',
  FINANCE_ADMIN = 'FINANCE_ADMIN',
  CFO = 'CFO',
  SYSTEM_ADMIN = 'SYSTEM_ADMIN'
}

export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: UserRole;
  departmentId: string;
}

export interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
}

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface RegisterData {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  role: UserRole;
  departmentId: string;
}

export interface AuthResponse {
  token: string;
  user: User;
}

export interface ChangePasswordData {
  oldPassword: string;
  newPassword: string;
} 